import {useEffect} from "react";
import Analytics from "../../../analytics";
import {toFixedFeatureCost} from "../../../misc/helpers";
import {getAnalyticsEcommerceItem} from "../../../analyticsEcommerceParams";
import {usePrevious} from "../../../misc/helperHooks";

export const useViewItemAnalyticsEvent = (lookActiveFeature, wizardActiveItem, fabricatorSettings) => {

  const prevActiveFeature = usePrevious(lookActiveFeature);

  useEffect(() => {
    if (!wizardActiveItem && lookActiveFeature && (!prevActiveFeature || (lookActiveFeature.dbFeature.id !== prevActiveFeature.dbFeature.id))) {
      Analytics.sendEcommerceEvent("view_item", {
        currency: fabricatorSettings.currency,
        value: +toFixedFeatureCost(lookActiveFeature, 1),
        items: [getAnalyticsEcommerceItem(lookActiveFeature, 1)]
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookActiveFeature])

}
